import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	dialogPopup: {
		maxWidth: 520,
		width: '100%',
	},
	messages: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		maxHeight: '60vh',
		overflowY: 'auto',
	},
	noMessages: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${SPACE[24]}px 0`,
		textAlign: 'center',
	},
});
